import { RefreshCadence } from "../types/insightFamilyRefreshCadence";

export const INSIGHT_DETAILS_TRIGGER_TEXT = "View insight details";
export const CREATE_INSIGHT_TRIGGER_TEXT = "Create insight deck";
export const WORKBENCH_CLF_SHARED = "feedback-shared";
export const NO_CONTENT_TEXT =
    "There are no insights of this type for this advertiser.";
export const INVALID_SCOPE_TEXT = "Search by an advertiser to see insights.";
export const INVALID_ADVERTISER_TEXT = (advertiserId: string): string =>
    `sfId query parameter must be alphanumeric and have a length of 18 but is ${advertiserId}`;
export const INVALID_MARKETPLACE_TEXT = (marketplaceId: string): string =>
    `marketplaceId query parameter must be numeric but is ${marketplaceId}`;
export const INSIGHT_REFRESH_STATUS_QUIP =
    "https://quip-amazon.com/NanSAlCyRUPf";
export const REFRESH_CADENCE_SLA_CONFIG = {
    [RefreshCadence.MONTHLY]: {
        refreshDay: 17,
    },
};
